import { RoutingPath } from 'mbs-ui-shared@constants';

export const adaptiveLayoutUrls = [RoutingPath.ApNewBackupHistory];
export const excludedFooterUrls = [RoutingPath.ApNewBackupHistory];
